import React, { FunctionComponent } from 'react';
import { Footer as MeshFooter, Link } from 'mesh-component-library';
import adChoices from '../../assets/images/AdChoices.png';

export const Footer: FunctionComponent = () => {
    return (
        <div data-testid="mesh-footer">
            <MeshFooter
                logoAlt="Allstate Insurance"
                hasPortal
                copyrightText={`\u00A9 ${new Date().getFullYear()} Allstate Insurance Company. All rights reserved.`}
                sponsorLink={
                    <div data-testid="adchoices-link">
                        <Link
                            hasPortal
                            style={{ paddingLeft: '0' }}
                            href="https://info.evidon.com/pub_info/3340?v=1"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img data-testid="adchoices-image" src={adChoices} width="78" height="19" alt="AdChoices" />
                        </Link>
                    </div>
                }
            >
                <div data-testid="privacy-link">
                    <Link
                        className="footer__link"
                        href="https://www.allstate.com/about/privacy-statement.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Statement
                    </Link>
                </div>
                <div data-testid="terms-link">
                    <Link
                        className="footer__link"
                        href="https://www.allstate.com/about/terms.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </Link>
                </div>
                <div data-testid="underwriting-link">
                    <Link
                        className="footer__link"
                        href="https://www.allstate.com/about/name-location.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Underwriting Companies
                    </Link>
                </div>
                <div data-testid="accessibility-link">
                    <Link
                        className="footer__link"
                        href="https://www.allstate.com/about/accessibility.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Website Accessibility
                    </Link>
                </div>
            </MeshFooter>
        </div>
    );
};

export default Footer;
